import i18n from '@/lang/i18n'

export default {
    title: i18n.t('configuration.elementTitle.automation'),
    id: 'automation',
    sidebar: [
        // TODO: Front debe echarle un vistazo para ver si se puede hacer mejor
        {
            id: 'personnel',
            label: i18n.t('configuration.sections.personnel'),
            icon: 'fal fa-hospital-user',
            routeName: 'AlgorithmsDefinition',
            active: true,
            hasChildren: true,
            children: [
                {
                    id: 'algorithmsDefinition',
                    label: i18n.t('configuration.sections.algorithmsDefinition'),
                    routeName: 'AlgorithmsDefinition'
                },
                {
                    id: 'algorithmsSelection',
                    label: i18n.t('configuration.sections.algorithmsSelection'),
                    routeName: 'AlgorithmsSelection'
                },
                {
                    id: 'entitiesAssociation',
                    label: i18n.t('configuration.sections.entitiesAssociation'),
                    routeName: 'EntitiesAssociation'
                }
            ]
        },
        {
            id: 'grossingShelves',
            label: i18n.tc('configuration.sections.grossingShelf', 2),
            icon: 'fal fa-container-storage',
            routeName: 'ImmediateShelfPriority',
            active: true,
            hasChildren: true,
            children: [
                {
                    id: 'immediateShelfPriority',
                    label: i18n.tc('configuration.sections.immediateShelfPriority', 2),
                    routeName: 'ImmediateShelfPriority'
                },
                {
                    id: 'intermediateShelfProcess',
                    label: i18n.tc('configuration.sections.intermediateShelfProcess', 2),
                    routeName: 'IntermediateShelfProcess'
                },
                {
                    id: 'sampleTypeAndShelf',
                    label: i18n.tc('configuration.sections.sampleTypeAndShelf', 2),
                    routeName: 'SampleTypeAndShelf'
                }
            ]
        },
        {
            id: 'portions',
            label: i18n.tc('configuration.sections.portion', 2),
            icon: 'icon-block',
            routeName: 'PortionNumberPerSample',
            active: true,
            hasChildren: true,
            children: [
                {
                    id: 'portionNumberPerSample',
                    label: i18n.t('configuration.sections.portionNumberPerSample'),
                    routeName: 'PortionNumberPerSample'
                }
            ]
        },
        {
            id: 'notifications',
            label: i18n.tc('configuration.sections.notification', 2),
            icon: 'fal fa-envelope',
            routeName: 'CaseNotification',
            active: true,
            hasChildren: true,
            children: [
                {
                    id: 'caseNotification',
                    label: i18n.t('entities.case.case'),
                    routeName: 'CaseNotification'
                }
            ]
        },
        {
            id: 'valuableConcept',
            label: i18n.tc('configuration.elementTitle.billing'),
            icon: 'fal fa-calculator',
            routeName: 'ValuableConceptAutomation',
            active: true,
            hasChildren: true,
            children: [
                {
                    id: 'billableConcepts',
                    label: i18n.tc('configuration.sections.billing'),
                    routeName: 'BillableConceptAutomation'
                },
                {
                    id: 'noBillableConcepts',
                    label: i18n.tc('configuration.sections.serviceActivity'),
                    routeName: 'ValuableConceptAutomation'
                }
                // TODO: Mockup next section, pending development
                /* {
                    id: 'nonBillableConcepts',
                    label: i18n.tc('configuration.sections.serviceActivity'),
                    routeName: 'NonBillableConceptAutomation'
                } */
            ]
        },
        {
            id: 'assays',
            label: i18n.tc('configuration.sections.assay', 2),
            icon: 'fas fa-flask',
            routeName: 'AssayAutomation',
            hasChildren: false
        },
        {
            id: 'protocols',
            label: i18n.tc('configuration.sections.protocol', 2),
            icon: 'fal fa-sitemap',
            routeName: 'ProtocolAutomation',
            hasChildren: false
        },
        {
            id: 'preformated',
            label: i18n.tc('configuration.sections.preformated', 2),
            icon: 'fal fa-copy',
            routeName: 'PreformattedAutomation',
            hasChildren: false
        }
    ]
}
